import { useState, useEffect } from 'react';
import Modal from 'react-modal';

const customStyles = {
    overlay: {
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        padding: '0',
        margin: '0',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'block'
    },
};

const defaultClasses = "modal-close c-btn button-default waves-effect waves-light button";

export default function ErrorModal({children, isOpen, close, secondButton}) {
    return <Modal
        isOpen={isOpen}
        onRequestClose={close}
        style={customStyles}
        contentLabel={"Error modal"}
        preventScroll={true}
        className="modal"
        ariaHideApp={false}
        >
            <div className="modal-content" data-role="dialog" aria-modal="true" aria-label="modal" style={{padding: "20px"}}>
                <h5>{children}</h5>
            </div>
            <div className="modal-footer padding-20" style={{height: "auto", background: "white", width: "100%"}}>
                <a data-testid="closeErrorModalButon" onClick={close} href="" className={`${defaultClasses} ${secondButton ? "float-left margin-right-10 margin-bottom-10-sm button--darkblue" : "button--red"}`}>Close</a>
                {secondButton}
            </div>
    </Modal>
}